export default __webpack_public_path__ + "static/media/Kimberly 9781408327975.3efffeb6.jpg";